import { render, staticRenderFns } from "./dropdown_address.vue?vue&type=template&id=6f00ebda"
import script from "./dropdown_address.vue?vue&type=script&lang=ts"
export * from "./dropdown_address.vue?vue&type=script&lang=ts"
import style0 from "./dropdown_address.vue?vue&type=style&index=0&id=6f00ebda&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports